import type {FieldsData} from './fields'
import {useQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

/** The fields a saved view can be arranged by, from the `fields.json` beside its views. */
export function useSavedViewFields(basePath: string) {
  return useQuery({
    queryKey: ['saved-view-fields', basePath],
    queryFn: async ({signal}): Promise<FieldsData> => {
      const response = await reactFetchJSON(`${basePath}/fields.json`, {signal})
      if (!response.ok) throw new Error(`Failed to fetch view options (${response.status})`)
      return response.json()
    },
    staleTime: Infinity,
    retry: false,
    // Both the configuration and the menu observe this query; a second mount after a
    // failure would otherwise fetch again.
    retryOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
}
